import { ListQuery } from '@onArte/shared/models/common';

export class SliderListQuery extends ListQuery {}
